import { Dialog } from "primereact/dialog";
import { useDispatch } from 'react-redux';

import Attachment from "./Attachment";

import downloadFile from "../utils/DownloadFile";
import { raiseToast } from "../services/redux/reducers/toast/toast";

import DocumentView from "./DocumentView";


const FileViewModal = (props) => {
    const { visible, document, handleOnHide, docName } = props

    const dispatch = useDispatch()

    const handleDownloadPDF = (pdfURL) => {
        if (pdfURL) {
            downloadFile(pdfURL, docName ? docName : '')
        }
        else {
            dispatch(raiseToast({ severity: 'error', detail: 'PDF was not found' }))
        }
    }

    const renderPDF = (pdfURL) => {
        return (
            <>
                {
                    pdfURL ?
                        <DocumentView fileUrl={pdfURL} showZoomControl={true}/>
                        : 
                        <p>The pdf file is not found</p>
                }
            </>
        )
    }

    const renderFile = (document) => {
        if(typeof(document) === "string"){
            if(document.split('.').pop().toLowerCase() === 'pdf'){
                return renderPDF(document)
            }
            else if(["png", "jpeg", "jpg", "png"].includes(document.split('.').pop().toLowerCase())){
                return (
                    <>
                        <img
                            src={document}
                            className="uploaded-image"
                            width="100%"
                            height="100%"
                            alt="expanded attachment"
                        />
                    </>
                )
            }
            else{
                return <Attachment url={document} displayFileName={true}/>
            }
        }
        else{
            // handleDownloadPDF(document)
        }
    }

    return (
        <Dialog visible={visible} style={{ width: '85vw', height: '85vh', backgroundColor: '#f8f8f8' }} onHide={handleOnHide}>
            {renderFile(document)}
        </Dialog>
    )
}

export default FileViewModal